import { useEffect, useRef } from 'react';
/**
 * Хук useInterval, для задач с использование setInterval включает в себя очистку интервала
 * @param callBack - функция интервала
 * @param delay - время тика, в ms
 */
function useInterval(callBack, delay) {
    var saveCallbackRef = useRef();
    useEffect(function () {
        saveCallbackRef.current = callBack;
    }, [callBack]);
    useEffect(function () {
        function tickInterval() {
            saveCallbackRef.current();
        }
        if (delay !== null) {
            var intervalId_1 = setInterval(tickInterval, delay);
            return function () {
                clearInterval(intervalId_1);
            };
        }
    }, [delay]);
}
export { useInterval };
//# sourceMappingURL=useInterval.js.map